import { TweenMax, TimelineMax } from 'gsap';
import { ScrollMagicPluginGsap } from 'scrollmagic-plugin-gsap';
import css from './index.module.scss';
import Details from './Details';
import ScrollMagicFn from '@/utils/ScrollMagic';

export default function River2() {
    // 这一段必须要先于子组件触发
    if (typeof window !== 'undefined' && typeof ScrollMagic == 'undefined') {
        window.ScrollMagic = ScrollMagicFn();
        ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);
    }

    return (
        <div className={`river2 ${css.river2}`}>
            <Details />
        </div>
    );
}
